import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2),
      '& .payment-success-message': {
        fontSize: 14,
        padding: '30px 0 15px 0',
      },
      '& .payment-success-image-container': {
        display: 'flex',
        justifyContent: 'center',
        padding: '40px 0',
        '& svg path': {
          maxWidth: 320,
        },
      },
      [theme.breakpoints.down('sm')]: {
        padding: 0,
        '& .payment-success-message': {
          padding: '10px 15px',
        },
        '& .payment-success-title': {
          fontWeight: 'bold',
          fontSize: 24,
          textAlign: 'center',
        },
      },
      [theme.breakpoints.down('xs')]: {
        '& .payment-success-image-container': {
          display: 'none',
          '& svg path': {
            fill: ({ primaryColor }: StyleProps) => primaryColor,
          },
        },
      },
    },
  }),
);

export default useStyles;
